module.exports = require('./internal/FixedDataTableRoot');



//////////////////
// WEBPACK FOOTER
// ./~/fixed-data-table/main.js
// module id = 38
// module chunks = 0